import * as React from 'react';
import { FooterLayout, FooterTop, formatPhone } from '@cian/frontend-e2e-deal-component';
import { TDeviceType, useDeviceType } from '@cian/ui-kit';

import { ConsultationRequestButtonContainer } from '../ConsultationRequestButtonContainer';
import { useCommonFooterData } from '../../utils/useCommonFooterData';

const FOOTER_PADDING: Record<TDeviceType, string> = {
  phone: '40px var(--section-padding-phone)',
  tablet: '40px var(--section-padding-tablet)',
  desktop: '60px var(--section-padding-desktop)',
};

export const PreFooterContainer = () => {
  const deviceType = useDeviceType();

  const footerData = useCommonFooterData();

  return (
    <div data-name="PreFooterContainer">
      <FooterLayout
        contentMaxWidth="var(--section-max-width)"
        background="#F4F4F4"
        padding={FOOTER_PADDING[deviceType]}
        topSection={
          <FooterTop
            email={footerData.email}
            phone={formatPhone({ phone: footerData.phone })}
            phoneDescription={footerData.phoneDescription}
            actionButton={
              <ConsultationRequestButtonContainer theme="fill_secondary">
                Хочу консультацию
              </ConsultationRequestButtonContainer>
            }
            qrContactCards={footerData.prepareQrData}
          />
        }
      />
    </div>
  );
};
